import React, {useMemo, useCallback} from 'react';
import {FlattedCategory} from '@/types/category';


import Form, {FormGeneratorHandles} from '@/components/Form';
import Splash from "@/components/splash/Splash";
import Button from "@/components/UiElements/Button";
import categoryFormItems from "./../forms/categoryFormItems";
import useStateManagement from "@/hooks/stateManagement/useStateManagement";
import saveCategoryStates from "../utils/saveCategoryStates";


interface CreateCategoryProps {
    onClose: () => void;
    parentId?: string | null;
    categoryList: FlattedCategory[];
    currentCategory?: FlattedCategory | null;
    updateCategoryCallback: () => void;
}

const CreateCategoryModal: React.FC<CreateCategoryProps> = ({ onClose, parentId = null, categoryList, currentCategory, updateCategoryCallback }) => {


    const formRef = React.useRef<FormGeneratorHandles>(null);
    const defaultValues = useMemo(() => {
        if (!currentCategory) {
            return {};
        }
        return {
            name: currentCategory.name,
            description: currentCategory.description,
            isActive: currentCategory.isActive,
            isGeneric: currentCategory.isGeneric || false,
            showOnHome: currentCategory.showOnHome,
            img: currentCategory.img
        };
    }, [currentCategory]);



    const handleStartSaveCategory = useCallback(() => {
        console.log("handleSaveCategory", formRef)
        handleSaveCategory({
            formRef,
            currentCategory,
            parentId,
            defaultValues,
            updateCategoryCallback,
        });
    }, [formRef, currentCategory, parentId, defaultValues, updateCategoryCallback]);


    const {
        runSteps: handleSaveCategory,
        stateInProgress,
    } = useStateManagement(
        {...saveCategoryStates}
    )

    return (
        <div className={"flex flex-col gap-xxxl"}>
            {stateInProgress && <Splash />}
            <div className={"w-[500px] grid grid-cols-12 gap-md"}>
                <Form
                    key={currentCategory?.id || 'new'}
                    ref={formRef}
                    items={categoryFormItems}
                    defaultValues={defaultValues}
                />
            </div>
            <div className={"flex flex-row justify-between gap-md"}>


                <Button
                    onClick={onClose}
                    type={"alt"}
                    className={"flex-1 inset-1"}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleStartSaveCategory}
                    className={"flex-1  inset-1"}
                >
                    {defaultValues.name ? "Update category" : "Create Category"}
                </Button>


            </div>
        </div>
    );
};

export default CreateCategoryModal;
